import { FormValidators } from '../../forms/validators/validators';
import { setupFormControl } from '../../forms/form.utilities';

(function () {
    window.addEventListener('DOMContentLoaded', (e) => {
        const page = document.getElementById('application-form');

        if (!page) return;

        setupFormControl('Required0', page, '.required-block-0', [ FormValidators.Required ] );
        setupFormControl('Required1', page, '.required-block-1', [FormValidators.Required]);
        setupFormControl('Email', page, '.email-block', [FormValidators.Email]);
        setupFormControl('Phone', page, '.phone-block', [FormValidators.Phone]);
        setupFormControl('IBAN', page, '.iban-block', [FormValidators.IBAN]);
    });
})();
